export const FETCH_UNDERGONE_SURGERY_REQUEST =
  "FETCH_UNDERGONE_SURGERY_REQUEST";
export const FETCH_UNDERGONE_SURGERY_SUCCESS =
  "FETCH_UNDERGONE_SURGERY_SUCCESS";
export const FETCH_UNDERGONE_SURGERY_FAIL = "FETCH_UNDERGONE_SURGERY_FAIL";

export const CREATE_UNDERGONE_SURGERY_REQUEST =
  "CREATE_UNDERGONE_SURGERY_REQUEST";
export const CREATE_UNDERGONE_SURGERY_SUCCESS =
  "CREATE_UNDERGONE_SURGERY_SUCCESS";
export const CREATE_UNDERGONE_SURGERY_FAIL = "CREATE_UNDERGONE_SURGERY_FAIL";

export const SHOW_UNDERGONE_SURGERY_REQUEST = "SHOW_UNDERGONE_SURGERY_REQUEST";
export const SHOW_UNDERGONE_SURGERY_SUCCESS = "SHOW_UNDERGONE_SURGERY_SUCCESS";
export const SHOW_UNDERGONE_SURGERY_FAIL = "SHOW_UNDERGONE_SURGERY_FAIL";

export const UPDATE_UNDERGONE_SURGERY_REQUEST =
  "UPDATE_UNDERGONE_SURGERY_REQUEST";
export const UPDATE_UNDERGONE_SURGERY_SUCCESS =
  "UPDATE_UNDERGONE_SURGERY_SUCCESS";
export const UPDATE_UNDERGONE_SURGERY_FAIL = "UPDATE_UNDERGONE_SURGERY_FAIL";
